import { APIConnector, LocalStorageEditor } from "@green24/npm-javascript-utils";
import { CubeSaveGenericServices } from "./api-connector";
import { DEFAULT_CONFIGURATION } from "../models/Models_Configuration";
import { AppUtils } from "../utils/AppUtils";

class ConfigurationServices extends CubeSaveGenericServices {
	getItem() {
		if(AppUtils.isDev) {
			let localConfig = LocalStorageEditor.get("localConfiguration");
			if(localConfig) {
				return Promise.resolve(localConfig);
			}
		}

		return new Promise(resolve => {
			this.sendRequest({
				url: "configuration.json",
				apiURL: '/',
			}).then(
				data => resolve(data),
				() => resolve(DEFAULT_CONFIGURATION)
			);
		});
	}

	saveItem(data) {
		if(AppUtils.isDev) {
			LocalStorageEditor.set("localConfiguration", data);
			return Promise.resolve(data);
		}

		return new Promise((resolve, reject) => {
			const xHttp = new XMLHttpRequest();

			xHttp.onreadystatechange = () => {
				if (xHttp.readyState == 4) {
					if(xHttp.status == 200) {
						resolve(data);
					}
					else {
						try {
							reject(JSON.stringify(xHttp.responseText));
						}
						catch (e) {
							reject(APIConnector.getErrorFromCode(500));
						}
					}
				}
			}

			xHttp.open("POST", "update_configuration.php", true);
			xHttp.setRequestHeader("Content-Type", "application/json");
			xHttp.send(JSON.stringify(data));
		});
	}
}


export const configurationServices = new ConfigurationServices();
